module.exports = __webpack_public_path__ + "img/horizontal_7_1_2.a8511db9.png";